import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { trackAnimeCardClick } from '../../../utils/analytics';

const toSlug = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

const AnimeCard = ({ anime }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const statusClass = anime.status === 'Currently Airing' ? 'airing'
        : anime.status === 'Not yet aired' ? 'upcoming'
        : 'finished';

    const statusLabel = anime.status === 'Currently Airing' ? 'Airing'
        : anime.status === 'Not yet aired' ? 'Upcoming'
        : 'Finished';

    const season = anime.season
        ? `${anime.season.charAt(0).toUpperCase() + anime.season.slice(1)} ${anime.year || ''}`
        : anime.year || '';

    const studio = anime.studios && anime.studios.length > 0
        ? anime.studios[0].name
        : null;

    return (
        <div className="small-anime-card" onClick={() => {
            trackAnimeCardClick(anime.mal_id, anime.title, location.pathname);
            navigate(`/animehub/anime/${anime.mal_id}-${toSlug(anime.title)}`);
        }}>
            <div className="small-anime-image-wrapper">
                <img
                    src={anime.images?.jpg?.image_url}
                    alt={anime.title}
                    className="small-anime-image"
                    loading="lazy"
                />
                <div className="small-anime-image-overlay"></div>
                <div className="anime-play-overlay">
                    <div className="anime-play-btn">&#9654;</div>
                </div>
                {anime.type && <span className="anime-type-badge">{anime.type}</span>}
                {anime.episodes && <span className="anime-ep-badge">{anime.episodes} EP</span>}
            </div>
            <div className="small-anime-info">
                <div className="anime-score-row">
                    <span className="small-anime-score">{anime.score || 'N/A'}</span>
                    {anime.scored_by && (
                        <span className="anime-scored-by">{(anime.scored_by / 1000).toFixed(0)}K</span>
                    )}
                </div>
                <h3 className="small-anime-title">{anime.title}</h3>
                <div className={`anime-status ${statusClass}`}>
                    <span className="anime-status-dot"></span>
                    {statusLabel}
                </div>
                <div className="anime-meta-row">
                    {season && <span className="anime-season">{season}</span>}
                    {studio && season && <span className="anime-meta-sep"></span>}
                    {studio && <span className="anime-studio">{studio}</span>}
                </div>
            </div>
        </div>
    );
};

export default AnimeCard;
